/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ProjectEntry = {
  /**
   * The ID of the project
   */
  id: string;
  /**
   * The name of the project
   */
  name: string;
  /**
   * A short url-friendly label that uniquely identifies a resource.
   */
  slug: string;
};

/** @internal */
export const ProjectEntry$inboundSchema: z.ZodMiniType<ProjectEntry, unknown> =
  z.object({
    id: z.string(),
    name: z.string(),
    slug: z.string(),
  });

export function projectEntryFromJSON(
  jsonString: string,
): SafeParseResult<ProjectEntry, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ProjectEntry$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ProjectEntry' from JSON`,
  );
}
